<template>
  <v-row>
    <v-col cols="12">
      <text-field-like
        :value="dataImplementation.name"
        label="名称"
        hide-details>
      </text-field-like>
    </v-col>
    <v-col cols="12">
      <text-field-like
        :value="dataImplementation.description"
        placeholder="未設定"
        label="説明"
        multi-line
        hide-details>
      </text-field-like>
    </v-col>
    <v-col cols="12">
      <local-id-field
        :value="dataImplementation.localId"
        label="内部ID"
        hide-details>
      </local-id-field>
    </v-col>
    <v-col cols="12">
      <text-field-like
        :value="dataImplementation.remarks"
        placeholder="未設定"
        label="備考"
        multi-line
        hide-details>
      </text-field-like>
    </v-col>
  </v-row>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import LocalIdField from "@/components/molecules/LocalIdField.vue";

export default {
  name: 'DataImplementationForm',
  components: {
    TextFieldLike,
    LocalIdField
  },
  model: {
    prop: 'dataImplementation'
  },
  props: {
    dataImplementation: {
      type: Object,
      required: true
    }
  }
}
</script>
